/* eslint-disable no-eval */
export const stringToJson = (record: any, field: string): any => {
  let obj;
  eval(`obj= ${String(record[field])}`);
  record[field] = obj;
  return record;
};
